import {del, get, post, put} from "../helpers/api_helper";
import {IOrderRule, IOrderRuleForm, IOrderRulePagination} from "../store/trafficManagement/orderRules/types";

export const OrderRuleService = {

    getRules: async (params?: any): Promise<IOrderRulePagination> => {
        return get('/traffic-orders-rule', {params});
    },

    getRuleById: async (id: number): Promise<IOrderRule> => {
        return get(`/traffic-orders-rule/${id}`);
    },

    createRule: async (data: IOrderRuleForm) => {
        return post(`/traffic-orders-rule`, data)
    },

    updateRule: async (id: number, data: IOrderRuleForm) => {
        return put(`/traffic-orders-rule/${id}`, data)
    },

    toggleStatusRule: async (id: number,) => {
        return get(`/traffic-orders-rule/${id}/status`)
    },

    removeRule: async (id: number) => {
        return del(`/traffic-orders-rule/${id}`)
    },
}